import { render, staticRenderFns } from "./PageFooterInrs.vue?vue&type=template&id=36d1d982&scoped=true&"
import script from "./PageFooterInrs.vue?vue&type=script&lang=js&"
export * from "./PageFooterInrs.vue?vue&type=script&lang=js&"
import style0 from "./PageFooterInrs.vue?vue&type=style&index=0&id=36d1d982&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1d982",
  null
  
)

export default component.exports